import { canUseDOM } from '@ps/web-core-utils';
import debounce from 'lodash/debounce';
import { useCallback, useEffect, useMemo, useState } from 'react';

const readScreen = () => (canUseDOM ? window.screen : undefined);

const useScreen = () => {
  const [screen, setScreen] = useState(readScreen());
  const debouncedSetScreen = useMemo(() => debounce(setScreen, 150), [setScreen]);

  const handleSize = useCallback(() => {
    const newScreen = readScreen();

    if (!newScreen) return;

    const { width, height, availHeight, availWidth, colorDepth, orientation, pixelDepth } =
      newScreen;

    debouncedSetScreen({
      width,
      height,
      availHeight,
      availWidth,
      colorDepth,
      orientation,
      pixelDepth
    });
  }, [debouncedSetScreen]);

  useEffect(() => {
    window.addEventListener('resize', handleSize);
    return () => window.removeEventListener('resize', handleSize);
  }, [handleSize]);

  return screen;
};

export default useScreen;
